import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { toPrice } from "../../../utils/toPrice";
import { updateWindowValue } from "../functions/updateWindowValue";
import { addNewPayment } from "../functions/addNewPayment";
import { deleteStyle } from "../functions/deleteStyle";
import { writePayLabel } from "../functions/writePayLabel";
import convertDate from "../../../utils/convertDate";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { quickNumberInput } from "../../../utils/quickNumberInput";
import { deletePaymentRecord } from "../functions/deletePaymentRecord";
import { purchasesCodes } from "../../../data/main";

export const paymentsModal = ({
  t,
  user,
  cPayments,
  vPayments,
  windowValues,
  setWindowValues,
  windowValues2,
  setWindowValues2,
  startSavePayments,
  modalData,
  closeMsg,
}: stdObject) => {
  const funcPack = {
    windowValues,
    setWindowValues,
    windowValues2,
    setWindowValues2,
  };
  return {
    title: modalData.title,
    label: modalData.label,
    blocked: true,
    mainColor: modalData.mainColor,
    table: [
      {
        data: [
          t("p.subtotal"),
          {
            text: windowValues.info ? toPrice(windowValues.info.NET) : 0,
            style: { textAlign: "right" },
          },
        ],
      },
      {
        data: [
          t("p.tax"),
          {
            text: windowValues.info ? toPrice(windowValues.info.IMP) : 0,
            style: { textAlign: "right" },
          },
        ],
      },
      {
        data: [
          t("p.total"),
          {
            text: windowValues.info ? toPrice(windowValues.info.TOT) : 0,
            style: { textAlign: "right" },
          },
        ],
        style: { fontWeight: "bolder" },
      },
      {
        data: [
          t("p.balance"),
          {
            text: toPrice(windowValues.BAL ? windowValues.BAL : 0),
            style: {
              textAlign: "right",
              color: windowValues.BAL > 0 ? colors.red : colors.black,
            },
          },
        ],
      },
      {
        data: [
          {
            type: "select",
            value: windowValues.PAY,
            onChange: (e: { target: { value: SetStateAction<string> } }) =>
              updateWindowValue({
                code: "PAY",
                value: e.target.value,
                ...funcPack,
              }),
            options: (purchasesCodes.includes(windowValues.type)
              ? cPayments
              : vPayments
            )
              .filter((e: stdObject) => e.ACTTPA === 1)
              .map((e: stdObject) => {
                return { label: e.NOMTPA, value: e.CODTPA };
              }),
          },
          {
            type: "number",
            value: windowValues.QTY,
            onChange: (e: { target: { value: SetStateAction<string> } }) => {
              updateWindowValue({
                code: "QTY",
                value: quickNumberInput(e.target.value, windowValues.QTY),
                ...funcPack,
              });
            },
            onKeyDown: (e: stdObject) => {
              switch (e.key) {
                case "Escape":
                case "Delete":
                  updateWindowValue({
                    code: "QTY",
                    value: "",
                    ...funcPack,
                  });
                  break;
                case "Enter":
                  if (Number(windowValues.QTY) !== 0) {
                    addNewPayment({
                      user,
                      windowValues,
                      setWindowValues,
                    });
                  }
                  break;
              }
            },
            style: { textAlign: "right" },
            innerStyle: { textAlign: "right", width: 80 },
          },
        ],
      },
      {
        data: [
          {
            type: "datetime-local",
            value: windowValues.DATE, //?? getCurrentDateTime(),
            colSpan: 2,
            onChange: (e: { target: { value: SetStateAction<string> } }) =>
              updateWindowValue({
                code: "DATE",
                value: e.target.value,
                ...funcPack,
              }),
          },
        ],
      },
      {
        data: [
          {
            type: "text",
            value: windowValues.OBS,
            placeholder: t("p.observations"),
            colSpan: 2,
            onChange: (e: { target: { value: SetStateAction<string> } }) =>
              updateWindowValue({
                code: "OBS",
                value: e.target.value,
                ...funcPack,
              }),
          },
        ],
      },
      {
        data: [
          {
            type: "button",
            label: t("p.add"),
            colSpan: 2,
            onClick: () =>
              addNewPayment({
                user,
                windowValues,
                setWindowValues,
              }),
            style: { justifyItems: "center" },
          },
        ],
      },
    ],
    table2: windowValues.records
      ? windowValues.records
          .map((e: stdObject, index: number) => {
            return [
              {
                data: [
                  {
                    type: "icon",
                    Icon: DeleteForeverIcon,
                    color: colors.red,
                    onClick: () =>
                      deletePaymentRecord(index, windowValues, setWindowValues),
                  },
                  {
                    text: convertDate({ info: e.FECDIN, t }),
                    style: deleteStyle(e.delete),
                  },
                  {
                    text: e.NOBDIN,
                    style: deleteStyle(e.delete),
                  },
                  {
                    text: writePayLabel(
                      e.TIPDIN,
                      windowValues?.info?.prefix === "c"
                        ? cPayments
                        : vPayments,
                    ),
                    style: deleteStyle(e.delete),
                  },
                  {
                    text: toPrice(e.CANDIN),
                    style: {
                      ...deleteStyle(e.delete),
                      textAlign: "right",
                    },
                  },
                ],
              },
              {
                data: [
                  {
                    text: "",
                    style: {
                      padding: 0,
                      color: e.delete ? colors.grey : colors.black,
                    },
                  },
                  {
                    text: e.OBSDIN,
                    style: {
                      padding: 0,
                      color: e.delete ? colors.grey : colors.black,
                    },
                    colSpan: 3,
                  },
                ],
              },
            ];
          })
          .flat()
      : [],
    buttons: [
      modalData.isEdit
        ? {
            label: t("p.save"),
            onClick: () => windowValues.changed && startSavePayments(),
            color: windowValues.changed ? colors.green : colors.darkGrey,
          }
        : null,
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
